// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { LicenseWithRelationsSchema } from './LicenseRelationsSchema'
import type { LicenseWithRelations } from './LicenseRelationsSchema'
import { ApplicationWithRelationsSchema } from './ApplicationRelationsSchema'
import type { ApplicationWithRelations } from './ApplicationRelationsSchema'
import { ApplicationGenerationLimitSchema } from './ApplicationGenerationLimitSchema';

/////////////////////////////////////////
// APPLICATION GENERATION LIMIT RELATION SCHEMA
/////////////////////////////////////////

export type ApplicationGenerationLimitRelations = {
  license: LicenseWithRelations;
  application: ApplicationWithRelations;
};

export type ApplicationGenerationLimitWithRelations = z.infer<typeof ApplicationGenerationLimitSchema> & ApplicationGenerationLimitRelations

export const ApplicationGenerationLimitWithRelationsSchema: z.ZodType<ApplicationGenerationLimitWithRelations> = ApplicationGenerationLimitSchema.merge(z.object({
  license: z.lazy(() => LicenseWithRelationsSchema),
  application: z.lazy(() => ApplicationWithRelationsSchema),
}))